import type { SanityCaseStudy } from '#/lib/sanity/queries/blogPost';
import { cn } from '#/lib/utils';
import { Image } from '#/components/Image';

export function CaseStudiesIntro(
  props: NonNullable<SanityCaseStudy['companyIntro']>,
) {
  const logo = props?.companyLogo;
  return (
    <div className="grid l:grid-cols-8 gap-x-20 l:grid-rows-2 gap-24 l:gap-0 mb-40">
      {logo ? (
        <div className="col-span-full l:col-span-3 row-span-1 col-start-1 l:row-start-1">
          <div
            className="l:mb-40 max-w-[var(--logo-w-mobile)] l:max-w-[var(--logo-w)]"
            style={
              {
                '--logo-w': props.companyLogoWidth
                  ? `${props.companyLogoWidth}px`
                  : undefined,
                '--logo-w-mobile': props.companyLogoMobileWidth
                  ? `${props.companyLogoMobileWidth}px`
                  : undefined,
              } as React.CSSProperties
            }
          >
            <Image image={logo} sizes="300px" />
          </div>
        </div>
      ) : null}
      <div
        className={cn(
          'col-span-full l:col-span-3 row-span-1 col-start-1 row-start-3',
          logo ? 'l:row-start-2' : 'l:row-start-1',
        )}
      >
        <ul className="text-14 leading-116 text-charcoal l:text-18 [&_span]:text-grayscale-04 [&_li>span]:mr-10 lg:[&_li>span]:min-w-80 [&_li>span]:min-w-65 [&_li>span]:inline-block font-[440] md:font-normal space-y-6 tracking-[-.18px] pr-20">
          {props.companyName && (
            <li>
              <span>Company</span> {props.companyName}
            </li>
          )}
          <li>
            <span>Industry</span>
            {props.industry}
          </li>
          <li>
            <span>Use Case</span>
            {props.useCase}
          </li>
        </ul>
      </div>
      <div className="col-span-full l:col-span-5 l:row-span-2 col-start-1 row-start-2 l:col-start-4 l:row-start-1">
        <p className="text-16 text-charcoal l:text-20 font-light leading-150 -tracking-2 max-w-[60ch]">
          {props.description}
        </p>
      </div>
    </div>
  );
}
